import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { ExportBillingReviewListState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "app/data/shipment-reconciliation/shipmentReconciliationService";
import { BillingReviewWorkItemRequest } from "app/data/shipment-reconciliation/models";

const initialState: ExportBillingReviewListState = {
  loading: false,
  loadingFailed: false,
  loaded: false
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const exportBillingReviewListSlice = createSlice({
  name: "exportBillingReviewList",
  initialState,
  reducers: {
    exportBillingReviewListResetState: (state) => initialState,
    exportBillingReviewListLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    exportBillingReviewListLoadingSucceed: (state) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
    },
    exportBillingReviewListLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
    }
  },
});

export const {
  exportBillingReviewListResetState,
  exportBillingReviewListLoadingStarted,
  exportBillingReviewListLoadingSucceed,
  exportBillingReviewListLoadingFailed
} = exportBillingReviewListSlice.actions;

export const exportBillingReviewListSelector = (state: IState) => state.exportBillingReviewList;

export const downloadBillingReviewCsv = (
  requestData: BillingReviewWorkItemRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  try {
    dispatch(exportBillingReviewListLoadingStarted());
    const response =  await shipmentReconciliationService.getBillingReviewListExport(requestData);
    const pdfBlob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(pdfBlob);
    const tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute(
      "download",
      "Billing Review.csv"
    );
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(url);
    dispatch(exportBillingReviewListLoadingSucceed());
  } catch (error) {
    dispatch(exportBillingReviewListLoadingFailed());
    onError && onError("Internal Server Error, re-try the action or contact support")
  }

};

const exportBillingReviewListReducer = exportBillingReviewListSlice.reducer;
export default exportBillingReviewListReducer;